import React from "react";

const CheckboxCheckedIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33337 1.33325H12.6667C13.7713 1.33325 14.6667 2.22868 14.6667 3.33325V12.6666C14.6667 13.7712 13.7713 14.6666 12.6667 14.6666H3.33337C2.2288 14.6666 1.33337 13.7712 1.33337 12.6666V3.33325C1.33337 2.22868 2.2288 1.33325 3.33337 1.33325ZM11.8667 5.73325C12.0876 5.4387 12.0279 5.02083 11.7334 4.79992C11.4388 4.579 11.021 4.6387 10.8 4.93325L7.26124 9.65165L5.13811 7.52851C4.87776 7.26816 4.45565 7.26816 4.1953 7.52851C3.93495 7.78886 3.93495 8.21097 4.1953 8.47132L6.31844 10.5945C6.89218 11.1682 7.84107 11.1008 8.32791 10.4516L11.8667 5.73325Z"
        fill="#537BFF"
      />
    </svg>
  );
};

export default CheckboxCheckedIcon;
